let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:

    (lib.Symbol11 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFFFF')
            .s()
            .p('AjAgXIDFhxIC8BuIkbCjg');
        this.shape.setTransform(-5, 0);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-24.3, -13.6, 38.6, 27.3);

    (lib.Symbol10 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AjNgrIGbjuIAAFFImbDug');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-20.6, -28.2, 41.3, 56.5);

    (lib.Symbol9 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AjbgkIG3j9IAAFGIlVDFIAAABIhhA3g');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-22, -29, 44, 58);

    (lib.Symbol7 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFFFF')
            .s()
            .p('AjsAcIEdikIC8BtIkdCkg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-23.7, -13.6, 47.4, 27.4);

    (lib.Symbol6 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('AhcBsIgBlFIC7BtIABFGg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-9.4, -21.7, 18.9, 43.6);

    (lib.Symbol5 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AiNhQIEbikIAAFGIkaCjg');
        this.shape.setTransform(9.4, 0);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#B9C4E3')
            .s()
            .p('AhdA2IAAhsIC6hsIABFFg');
        this.shape_1.setTransform(-14.2, 8.2);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-23.6, -24.5, 47.2, 49);

    (lib.Symbol3 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AiOhQIEcikIABFFIkcCkg');
        this.shape.setTransform(9.4, 0);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#B9C4E3')
            .s()
            .p('AhdBtIgBlGIC7BuIABFFg');
        this.shape_1.setTransform(-14.2, 2.7);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-23.6, -24.5, 47.3, 49);

    (lib.Symbol2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFFFF')
            .s()
            .p('AjrAbIEbijIC8BuIkbCjg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-23.6, -13.7, 47.2, 27.4);

    (lib.Symbol1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_11 (mask)
        const mask = new cjs.Shape();
        mask._off = true;
        const mask_graphics_0 = new cjs.Graphics().p('AkDAcIEcikIC9BtIkdCkg');
        const mask_graphics_1 = new cjs.Graphics().p('AkDAcIEdikIC8BtIkdCkg');
        const mask_graphics_2 = new cjs.Graphics().p('AkCAcIEdikIC8BtIkdCkg');
        const mask_graphics_3 = new cjs.Graphics().p('AkAAcIEcikIC9BtIkdCkg');
        const mask_graphics_4 = new cjs.Graphics().p('Aj+AcIEcikIC9BtIkdCkg');
        const mask_graphics_5 = new cjs.Graphics().p('Aj7AcIEcikIC9BtIkdCkg');
        const mask_graphics_6 = new cjs.Graphics().p('Aj4AcIEdikIC8BtIkdCkg');
        const mask_graphics_7 = new cjs.Graphics().p('Aj0AcIEdikIC8BtIkdCkg');
        const mask_graphics_8 = new cjs.Graphics().p('AjvAcIEdikIC8BtIkdCkg');
        const mask_graphics_9 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_10 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_11 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_12 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_13 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_14 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_15 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_16 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_17 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_18 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_19 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_29 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_30 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_31 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_32 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_33 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_34 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_35 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_36 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_37 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_38 = new cjs.Graphics().p('AjsAcIEdikIC8BtIkdCkg');
        const mask_graphics_39 = new cjs.Graphics().p('AjsAcIEcikIC9BtIkdCkg');
        const mask_graphics_40 = new cjs.Graphics().p('AjuAcIEdikIC8BtIkdCkg');
        const mask_graphics_41 = new cjs.Graphics().p('AjyAcIEcikIC9BtIkdCkg');
        const mask_graphics_42 = new cjs.Graphics().p('Aj2AcIEcikIC9BtIkdCkg');
        const mask_graphics_43 = new cjs.Graphics().p('Aj6AcIEdikIC8BtIkdCkg');
        const mask_graphics_44 = new cjs.Graphics().p('Aj8AcIEcikIC9BtIkdCkg');
        const mask_graphics_45 = new cjs.Graphics().p('Aj/AcIEdikIC8BtIkdCkg');
        const mask_graphics_46 = new cjs.Graphics().p('AkAAcIEcikIC9BtIkdCkg');
        const mask_graphics_47 = new cjs.Graphics().p('AkCAcIEdikIC8BtIkdCkg');
        const mask_graphics_48 = new cjs.Graphics().p('AkDAcIEdikIC8BtIkdCkg');
        const mask_graphics_49 = new cjs.Graphics().p('AkDAcIEcikIC9BtIkdCkg');

        this.timeline.addTween(
            cjs.Tween.get(mask)
                .to({graphics: mask_graphics_0, x: -26, y: 0.1})
                .wait(1)
                .to({graphics: mask_graphics_1, x: -26, y: 0})
                .wait(1)
                .to({graphics: mask_graphics_2, x: -25.9, y: -0.1})
                .wait(1)
                .to({graphics: mask_graphics_3, x: -25.7, y: -0.2})
                .wait(1)
                .to({graphics: mask_graphics_4, x: -25.5, y: -0.5})
                .wait(1)
                .to({graphics: mask_graphics_5, x: -25.2, y: -0.8})
                .wait(1)
                .to({graphics: mask_graphics_6, x: -24.9, y: -1.2})
                .wait(1)
                .to({graphics: mask_graphics_7, x: -24.5, y: -1.7})
                .wait(1)
                .to({graphics: mask_graphics_8, x: -24, y: -2.2})
                .wait(1)
                .to({graphics: mask_graphics_9, x: -23.3, y: -2.8})
                .wait(1)
                .to({graphics: mask_graphics_10, x: -22.3, y: -3.4})
                .wait(1)
                .to({graphics: mask_graphics_11, x: -21.3, y: -4})
                .wait(1)
                .to({graphics: mask_graphics_12, x: -20.4, y: -4.5})
                .wait(1)
                .to({graphics: mask_graphics_13, x: -19.6, y: -4.9})
                .wait(1)
                .to({graphics: mask_graphics_14, x: -19, y: -5.3})
                .wait(1)
                .to({graphics: mask_graphics_15, x: -18.5, y: -5.6})
                .wait(1)
                .to({graphics: mask_graphics_16, x: -18.1, y: -5.8})
                .wait(1)
                .to({graphics: mask_graphics_17, x: -17.8, y: -6})
                .wait(1)
                .to({graphics: mask_graphics_18, x: -17.6, y: -6.1})
                .wait(1)
                .to({graphics: mask_graphics_19, x: -17.5, y: -6.1})
                .wait(10)
                .to({graphics: mask_graphics_29, x: -17.5, y: -6.1})
                .wait(1)
                .to({graphics: mask_graphics_30, x: -17.6, y: -6.1})
                .wait(1)
                .to({graphics: mask_graphics_31, x: -17.8, y: -6})
                .wait(1)
                .to({graphics: mask_graphics_32, x: -18.1, y: -5.8})
                .wait(1)
                .to({graphics: mask_graphics_33, x: -18.4, y: -5.6})
                .wait(1)
                .to({graphics: mask_graphics_34, x: -18.9, y: -5.3})
                .wait(1)
                .to({graphics: mask_graphics_35, x: -19.6, y: -5})
                .wait(1)
                .to({graphics: mask_graphics_36, x: -20.3, y: -4.5})
                .wait(1)
                .to({graphics: mask_graphics_37, x: -21.2, y: -4})
                .wait(1)
                .to({graphics: mask_graphics_38, x: -22.1, y: -3.5})
                .wait(1)
                .to({graphics: mask_graphics_39, x: -23.1, y: -2.9})
                .wait(1)
                .to({graphics: mask_graphics_40, x: -23.9, y: -2.4})
                .wait(1)
                .to({graphics: mask_graphics_41, x: -24.3, y: -1.9})
                .wait(1)
                .to({graphics: mask_graphics_42, x: -24.7, y: -1.4})
                .wait(1)
                .to({graphics: mask_graphics_43, x: -25.1, y: -1})
                .wait(1)
                .to({graphics: mask_graphics_44, x: -25.3, y: -0.7})
                .wait(1)
                .to({graphics: mask_graphics_45, x: -25.6, y: -0.4})
                .wait(1)
                .to({graphics: mask_graphics_46, x: -25.7, y: -0.2})
                .wait(1)
                .to({graphics: mask_graphics_47, x: -25.9, y: -0.1})
                .wait(1)
                .to({graphics: mask_graphics_48, x: -26, y: 0})
                .wait(1)
                .to({graphics: mask_graphics_49, x: -26, y: 0.1})
                .wait(11)
        );

        // Layer_8
        this.instance = new lib.Symbol7('synched', 0);
        this.instance.parent = this;
        this.instance.setTransform(-28.3, 0.1);

        const maskedShapeInstanceList = [this.instance];

        for (let shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({x: -28, y: -0.1}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({startPosition: 0}, 0)
                .to({x: -28.3, y: 0.1}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );

        // Symbol 6
        this.instance_1 = new lib.Symbol6('synched', 0);
        this.instance_1.parent = this;
        this.instance_1.setTransform(-42.5, 24.6);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .to({x: -31.8, y: 18.4}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({startPosition: 0}, 0)
                .to({x: -42.5, y: 24.6}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );

        // Layer_3
        this.instance_2 = new lib.Symbol10('synched', 0);
        this.instance_2.parent = this;
        this.instance_2.setTransform(31.4, -7.1);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_2)
                .to({x: 18, y: 0.7}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({startPosition: 0}, 0)
                .to({x: 31.4, y: -7.1}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );

        // Layer_13
        this.instance_3 = new lib.Symbol9('synched', 0);
        this.instance_3.parent = this;
        this.instance_3.setTransform(-11.2, 17.4);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_3)
                .to({x: -0.4, y: 11.2}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({startPosition: 0}, 0)
                .to({x: -11.2, y: 17.4}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );

        // Symbol 2
        this.instance_4 = new lib.Symbol2('synched', 0);
        this.instance_4.parent = this;
        this.instance_4.setTransform(0.1, -48.5);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_4)
                .to({x: 0.2, y: -16.1}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({y: -15.9}, 0)
                .to({x: 0.1, y: -48.5}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );

        // Symbol 3
        this.instance_5 = new lib.Symbol3('synched', 0);
        this.instance_5.parent = this;
        this.instance_5.setTransform(0.2, -26.8);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_5)
                .to({x: 0.4, y: 5.4}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({y: 5.3}, 0)
                .to({x: 0.2, y: -26.8}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );

        // Layer_14
        this.instance_6 = new lib.Symbol10('synched', 0);
        this.instance_6.parent = this;
        this.instance_6.setTransform(12.9, 3.5);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_6)
                .wait(19)
                .to({startPosition: 0}, 0)
                .wait(10)
                .to({startPosition: 0}, 0)
                .wait(20)
                .to({startPosition: 0}, 0)
                .wait(11)
        );

        // Layer_5
        this.instance_7 = new lib.Symbol11('synched', 0);
        this.instance_7.parent = this;
        this.instance_7.setTransform(37.8, -32.7);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_7)
                .to({x: 24.4, y: -24.9}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({startPosition: 0}, 0)
                .to({x: 37.8, y: -32.7}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );

        // Layer_4
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFFFF')
            .s()
            .p('AjsA4IF5jbIAAATIBFAAIAbCQIkcCkg');
        this.shape.setTransform(0.2, -19.2);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(60));

        // Symbol 5
        this.instance_8 = new lib.Symbol5('synched', 0);
        this.instance_8.parent = this;
        this.instance_8.setTransform(0.2, 37.9);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_8)
                .to({y: 5.5}, 19, cjs.Ease.quadInOut)
                .wait(10)
                .to({startPosition: 0}, 0)
                .to({y: 37.9}, 20, cjs.Ease.quadInOut)
                .wait(11)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-52, -62.2, 104.1, 124.6);

    // stage content:
    (lib._4 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_2
        this.instance = new lib.Symbol1('synched', 0);
        this.instance.parent = this;
        this.instance.setTransform(52, 80.6);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(60));

        // Layer_3
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AD4r5IDWh8IrJZtIjSB+g');
        this.shape.setTransform(112.9, 100.9);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#FFFFFF')
            .s()
            .p('AjVAAIDVh6IDWB6IjWB7g');
        this.shape_1.setTransform(137.6, 12.4);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#B9C4E3')
            .s()
            .p('AnPL3ILJ5sIDWB8IrFZvg');
        this.shape_2.setTransform(91.2, 100.9);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(60)
        );

        // Symbol 1
        this.instance_1 = new lib.Symbol1('synched', 29);
        this.instance_1.parent = this;
        this.instance_1.setTransform(155.4, 85.7);

        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(60));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(97, 95, 224, 189.5);
    // library properties:
    lib.properties = {
        id: '070D5A01EC654527B17A49D882B52A51',
        width: 224,
        height: 190,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['070D5A01EC654527B17A49D882B52A51'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('070D5A01EC654527B17A49D882B52A51');

export {AdobeAn};
export {composition};
